import { isEqual } from 'lodash';
import isEmpty from 'lodash.isempty';
import { useDispatch } from 'react-redux';
import {
  createPersonPhone,
  updatePersonPhone,
} from '../store/actions/person/personActions';
import useApplicationUid from './useApplicationUid';

const usePersonPhoneNumberDispatch = () => {
  const dispatch = useDispatch();
  const { ApplicationUid } = useApplicationUid();

  const personPhoneDispatch = ({
    personUid,
    data,
    defaultValues,
    onSuccess,
    onError,
  }) => {
    const shouldSkip = isEqual(data?.PersonPhoneNumberFormatted, defaultValues);

    if (shouldSkip) {
      onSuccess();
      return;
    }

    const requestData = {
      ApplicationUid,
      PersonUid: personUid,
      data: data?.PersonPhoneNumberFormatted,
      onSuccess,
      onError,
    };
    if (defaultValues?.Iso3CountryCode || !isEmpty(defaultValues)) {
      dispatch(
        updatePersonPhone({
          ...requestData,
        }),
      );
      return;
    }

    dispatch(
      createPersonPhone({
        ...requestData,
      }),
    );
  };

  return { personPhoneDispatch };
};

export default usePersonPhoneNumberDispatch;
